import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Cache } from "aws-amplify";
import TimesheetApprovals from "../timesheet/TimesheetApprovals";
import ProjectApprovals from "../projects/ProjectApprovals";
import {
  PROJECT_SPONSOR,
  FINANCE_APPROVER,
  MANAGER,
  TEAM_LEADER,
  fetchNonICRoles,
} from "../../store/actions/users/usersActions";
import { resetIsSaving } from "../../store/actions/commonActions";

import PageTitle from "../../common/PageTitle";

class Approvals extends Component {
  componentDidMount() {
    this.props.resetIsSaving();
  }

  displayTimesheetApprovals = () => {
    const roleId = Cache.getItem("roleId");
    const nonICRoles = fetchNonICRoles();
    if (nonICRoles.includes(roleId)) {
      return (
        <Row className="mt-2">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <TimesheetApprovals />
          </Col>
        </Row>
      );
    }
    return "";
  };

  displayProjectApprovals = () => {
    const roleId = Cache.getItem("roleId");
    if (
      roleId === PROJECT_SPONSOR ||
      roleId === FINANCE_APPROVER ||
      roleId === MANAGER ||
      roleId === TEAM_LEADER
    ) {
      return (
        <Row className="mt-5">
          <Col>
            <ProjectApprovals />
          </Col>
        </Row>
      );
    }
    return "";
  };

  render() {
    let roleId = Cache.getItem("roleId");
    let defaultUserRole = this.props.users.defaultUserRole;

    const urlParams = new URLSearchParams(this.props.location.search);
    const paramRoleId = urlParams.get("role_id");

    if (defaultUserRole) {
      roleId = defaultUserRole.id;
    }

    if (paramRoleId && roleId !== +paramRoleId) {
      return "Loading...";
    }

    const allowedRoles = fetchNonICRoles();

    if (!allowedRoles.includes(roleId)) {
      this.props.history.push("/dashboard");
    }

    return (
      <>
        <PageTitle pageName="Approvals" />

        {this.displayTimesheetApprovals()}
        {this.displayProjectApprovals()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetIsSaving: () => dispatch(resetIsSaving()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Approvals)
);
